/**
 * @param timeoutId {number}
 */
module.exports = function cancelRoiCalculatorLoadingTimeout(timeoutId) {
    clearTimeout(timeoutId);
}